import React from 'react';
import {motion} from "framer-motion";
import s from "./FeesBusinessAccount.module.css";
import {Link} from "react-router-dom";
import MyBtn from "../../../components/ui/MyBtn/MyBtn";
import ellipse from '../../../assets/img/ellipse.svg'
import emptyEllipse from '../../../assets/img/eclipse-empty.svg'
import {Helmet} from "react-helmet-async";

const FeesBusinessAccount = () => {
    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >

            <Helmet>
                <title>Open a Business Account with dedicated IBAN, SEPA Payments and FX Solutions</title>
                <meta
                    name="description"
                    content="Open Business Accounts,With dedicated IBANs, SEPA & SEPA Instant transfers, multi-currency
                    FX, B2B and C2B payment solutions, online banking tools, and secure digital finance."
                />
                <meta name="keywords" content="business IBAN account, SEPA payments, B2B digital banking, dedicated IBAN"/>
            </Helmet>

            <div className={s.wrapper}>
                 <div className={s.small_elipse_container}>
                        <img src={ellipse} alt="" />
                    </div>

                    <div className={s.high_elipse_container}>
                        <img src={emptyEllipse} alt="" />
                    </div>
                <div className={s.container}>
                    <div className={s.desc_block}>
                        <div className={s.title_block}>
                            <h2 className={s.title}>
                                <span className={s.underline}>Open Payment Account </span> to pay your suppliers and
                                bills.
                                Or receive payments from your customers.
                            </h2>
                        </div>
                        <div className={s.points_block}>
                            <p className={s.description}>
                                1. We provide SEPA transfers to our clients despite their location.
                            </p>
                            <p className={s.description}>
                                2. Cross-border multicurrency — SWIFT payments in EUR, GBP.
                            </p>
                            <p className={s.description}>
                                3. Acquiring services — <span className={s.coming_soon}>coming soon.</span>
                            </p>
                        </div>
                        <div className={s.button_wrapper}>
                            <Link to={"/sign-up"}>
                                <MyBtn title={"Open Payment Account"}/>
                            </Link>
                        </div>

                        <div className={s.table_block}>
                            <div className={s.header}>
                                <span>Card fees and payment fees</span>
                                <span className={s.row_value}>Fee (EUR)</span>
                            </div>
                            <div className={s.body}>
                                <div className={s.row}>
                                    <span className={s.row_text}>Card Load Fee (%)</span>
                                    <span className={s.row_value}>00.15% <br/> <span className={s.color_value}>(min 3.5 EUR)</span></span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Purchase Fee (in-store/online) International</span>
                                    <span className={s.row_value}>00.15 <span className={s.color_value}>+ 1.20 %</span></span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Purchase Fee (in-store/online) Domestic</span>
                                    <span className={s.row_value}>00.15 <span className={s.color_value}>+ 0.30 %</span></span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Cash Withdrawal Domestic</span>
                                    <span className={s.row_value}>01.50</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Cash Withdrawal International</span>
                                    <span className={s.row_value}>01.50 <span className={s.color_value}>+ 1.50 %</span></span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Cash Withdrawal Decline</span>
                                    <span className={s.row_value}>00.50</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>ATM Balance Inquiry</span>
                                    <span className={s.row_value}>0.00</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Foreign Exchange (%)</span>
                                    <span className={s.row_value}>1.00%</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Card Issuing*</span>
                                    <span className={s.row_value}>10.00</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Card Monthly fee</span>
                                    <span className={s.row_value}>10.00</span>
                                </div>
                            </div>
                            <span className={s.additional_price}>**Price for delivery by post. Delivery by courier possible for additional fee depending on the recipient’s country</span>
                        </div>

                        <div className={s.table_block}>
                            <div className={s.header}>
                                <span> Card transactions limits</span>
                                <span className={s.row_value}>EUR</span>
                            </div>
                            <div className={s.body}>
                                <div className={s.row}>
                                    <span className={s.row_text}>Card Max Balance</span>
                                    <span className={s.row_value}>20.000 </span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Top-up daily</span>
                                    <span className={s.row_value}>5.000</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Top-up monthly</span>
                                    <span className={s.row_value}>40.000</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Top-up annual </span>
                                    <span className={s.row_value}>200.000</span>
                                </div>

                                <div className={s.row}>
                                    <span className={s.row_text}>Ecommerce - max value per transaction / per day</span>
                                    <span className={s.row_value}>5.000</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default FeesBusinessAccount;
